<template>
    <div class="datePicker">
        <input type="text" :value="inputValue ? inputValue : longDate(true, true, true)" readonly="readonly" @click="toggleDatePicker" @keydown="keyPressed($event)" />
        <div class="calendar" v-if="displayDatePicker">
            <div class="navBar">
                <span @click="prevMonth"><img class="navBtn" src="https://preprod.api.defipix.fr/logos/prev_200.png"/></span>
                <span class="title">{{longCurrentDate(false, true, true)}}</span>
                <span @click="nextMonth"><img class="navBtn" src="https://preprod.api.defipix.fr/logos/next_200.png"/></span>
            </div>
            <div class="days">
                <div v-for="name in dayName" v-bind:key="name">{{name.slice(0,3)}}</div>
                <div v-for="blankDay in blankDay()" v-bind:key="`blankDay_${blankDay}`" />
                <div v-for="day in new Date(currentDate.getFullYear(), currentDate.getMonth()+1, 0).getDate()" v-bind:key="`day_${day}`" :id="`day_${day}`" class="day" @click="setDate(day)">{{day}}</div>
            </div>
        </div>
    </div>
</template>

<script>
import JQuery from 'jquery';
let $ = JQuery;

export default {
    data() {
        return {
            displayDatePicker: false,
            date: null,
            currentDate: new Date(),
            dayName: ['Lundi', 'Mardi', 'Mercredi', 'Jeudi', 'Vendredi', 'Samedi', 'Dimanche'],
            inputValue: "",
        }
    },
    mounted: function() {
        if (this.$attrs.value) {
            this.date = new Date(this.$attrs.value);
            $( `#day_${this.date.getDate()}` ).css('background-color', "#f677c4");
        }
        let self = this;
        $('body').click(function(e){
            let container = $(".datePicker");
            if (!container.is(e.target) && container.has(e.target).length === 0) 
            {
                self.displayDatePicker = false;
            }
        });
    },
    updated: function() {
        $( ".day" ).each(function( index ) {
            $(this).css('background-color', 'unset');
        });
        if (this.date && this.currentDate.getMonth() === this.date.getMonth() && this.currentDate.getFullYear() === this.date.getFullYear()) {
            $( `#day_${this.date.getDate()}` ).css('background-color', "#f677c4");
        }
    },
    methods: {
        blankDay() {
            let result;
            if (this.date) {
                result = new Date(this.date.getFullYear(), this.date.getMonth(), 1).getDay();
            } else {
                result = new Date(this.currentDate.getFullYear(), this.currentDate.getMonth(), 1).getDay();
            }
            result > 0 ? result-- : null;
            return result;
        },
        toggleDatePicker() {
            this.displayDatePicker = !this.displayDatePicker;
        },
        longDate(day, month, year) {
            const options = {
                day: day ? "numeric" : undefined,
                month: month ? "long" : undefined,
                year: year ? "numeric" : undefined,
            };
            if (this.date) return this.date.toLocaleDateString("fr-FR", options);
            return null;
        },
        longCurrentDate(day, month, year) {
            const options = {
                day: day ? "numeric" : undefined,
                month: month ? "long" : undefined,
                year: year ? "numeric" : undefined,
            };
            return this.currentDate.toLocaleDateString("fr-FR", options);
        },
        nextMonth() {
            this.currentDate = new Date(this.currentDate.setMonth(this.currentDate.getMonth()+1));
        },
        prevMonth() {
            this.currentDate = new Date(this.currentDate.setMonth(this.currentDate.getMonth()-1));
        },
        setDate(day) {
            this.date = new Date(this.currentDate.setDate(day));
            this.$emit('input', this.date);
            this.inputValue = "";
        },
        keyPressed(e) {
            if(e.keyCode >= 96 && e.keyCode <= 105 || e.keyCode >= 48 && e.keyCode <= 57) {
                if (isNaN(Number(e.key))) return;
                if (this.inputValue.length <= 2) {
                    if (!this.inputValue) {
                        this.inputValue = `${e.key}`;
                        return;
                    } else {
                        this.inputValue += e.key;
                        if (Number(this.inputValue) > new Date(this.currentDate.getFullYear(), this.currentDate.getMonth()+1, 0).getDate()) {
                            this.inputValue = Number(new Date(this.currentDate.getFullYear(), this.currentDate.getMonth()+1, 0).getDate());
                        }
                        this.inputValue += "/";
                        return;
                    }
                } else if(this.inputValue.length <= 5) {
                    let monthValue = this.inputValue.split("/")[1];
                    if (!monthValue) {
                        this.inputValue = `${this.inputValue.split("/")[0]}/${e.key}`;
                        return;
                    } else {
                        this.inputValue += e.key;
                        if (Number(this.inputValue.split("/")[1]) > 12) {
                            this.inputValue = `${this.inputValue.split("/")[0]}/12`;
                        }
                        this.inputValue += "/20";
                        return;
                    }
                } else {
                    let yearValue = Number(this.inputValue.split("/")[2]);
                    if (yearValue === 0) {
                        if (e.key == 0) return;
                        this.inputValue += e.key;
                        return;
                    } else if(String(yearValue).length < 4) {
                        this.inputValue += e.key;
                        let val = this.inputValue.split("/");
                        if(val[2].length == 4) {
                            let finalDate = `${val[1]}/${val[0]}/${val[2]}`;
                            this.date = new Date(finalDate);
                            this.currentDate = new Date(finalDate);
                            this.$emit('input', this.date);
                            this.inputValue = "";
                        }
                        return;
                    }
                }
            } else if (e.keyCode == 8) {
                if (!this.inputValue) return;
                if (this.inputValue.slice(-3) == "/20") {
                    this.inputValue = this.inputValue.slice(0, -3);
                    return;
                }
                if (this.inputValue.slice(-1) == "/") {
                    this.inputValue = this.inputValue.slice(0, -2);
                } else {
                    this.inputValue = this.inputValue.slice(0, -1);
                }
                return;
            } else if (e.key == "/") {
                if (this.inputValue.slice(-1) == "/" || this.inputValue.slice(-1) == 0) return;
                if (this.inputValue.length == 1) {
                    this.inputValue = `0${this.inputValue}/`;
                } else if(this.inputValue.length == 4) {
                    this.inputValue = `${this.inputValue.slice(0, -1)}/0${this.inputValue.slice(-1)}/`;
                } else {
                    return;
                }
            }
        }
    }
}
</script>

<style scoped>
    .datePicker {
        position: relative;
    }

    .calendar {
        background-color: white;
        border: 1px solid #25327B;
        border-radius: 5px;
        position: absolute;
        z-index: 100;
        width: 100% !important;
    }

    .navBar {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
    }

    .navBtn {
        width: 1.5em;
        margin: .75em;
    }

    .navBtn:hover, .day:hover {
        cursor: pointer;
    }

    .title {
        font-weight: bold;
    }

    .days {
        display: grid;
        grid-template-columns: auto auto auto auto auto auto auto;
    }

    .days>* {
        padding: 5px 0;
        border: 1px solid transparent;
    }

    .day:hover {
        border: 1px solid #f677c4;
    }
</style>


// WEBPACK FOOTER //
// src/components/OrderBooth/DatePicker.vue